(function($) {
    // fallback for ajax-loaded content when ScrollReveal isn't active (IE / no-sr)
    window.srRevealGroup = function($elements) {
        $elements.attr("data-reveal", "revealed").removeAttr("style");
    };

    if (!$("html.ie").length && !$("html.no-sr").length) {
        window.sr = ScrollReveal({ duration: 2000 });
        if (sr.isSupported()) {
            document.documentElement.classList.add('sr');

            var groupConfig = {
                duration: 500,
                easing: 'ease',
                scale: null,
                distance: 0,
                delay: 150,
                viewFactor : 0.2,
                reset: false,
                mobile: true,
                container: document.getElementsByTagName("section"),
                beforeReveal: function (domEl) {
                    $(domEl).attr("data-reveal","revealed");
                },
                afterReveal: function (domEl) {
                    $(domEl).removeAttr("style");
                }
            };

            // reveal newly-inserted (eg. ajax-loaded) [data-reveal] elements
            // as if they had just scrolled into view
            window.srRevealGroup = function($elements) {
                sr.reveal($elements, groupConfig, 150);
            };

            $("#layout_main").children("section, article").each(function(){
                var c = $(this).attr("class").split(' ')[0];
                var s = $(this).index() + 1;
                sr.reveal("."+c+":nth-child("+s+") [data-reveal]", {
                    duration: 1000,
                    easing: 'ease',
                    scale: null,
                    distance: 0,
                    delay: 300,
                    viewFactor : 0.2,
                    reset: false,
                    mobile: true,
                    container: document.getElementsByTagName("section"),
                    beforeReveal: function (domEl) {
                        $(domEl).attr("data-reveal","revealed");
                    },
                    afterReveal: function (domEl) {
                        $(domEl).removeAttr("style");
                    }
                },0);
                $(this).find("[data-reveal-group]").each(function(i){
                    var g = $(this).attr("class").split(' ')[0];
                    sr.reveal("."+c+":nth-child("+s+") ."+g+" [data-reveal]", groupConfig, 150);
                });
            });
        } else {
            document.documentElement.classList.add('no-sr');
        }
    }
})(jQuery);